import React, {Component} from 'react';
import './UserMenu.css';
import actions from './session.actions';
import {uiActions} from '../chrome';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import Notifications from './Notifications';

class UserMenu extends Component {
	constructor() {
		super();

		this.clickOut = e => {
			//if (this.dialogEl && !this.dialogEl.contains(e.target) && this.dialogEl !== e.target) {
			if (this.props.toggleUserMenu) this.props.toggleUserMenu();
			//}
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.userMenuShown && !this.props.userMenuShown) {
			document.body.addEventListener('click', this.clickOut);
		} else if (!nextProps.userMenuShown && this.props.userMenuShown) {
			document.body.removeEventListener('click', this.clickOut);
		}
	}

	componentWillUnmount() {
		if (this.props.userMenuShown) {
			document.body.removeEventListener('click', this.clickOut);
		}
	}

	render() {
		const {userMenuShown, logout, current} = this.props;

		return (
			<section className={`UserMenu ${userMenuShown ? 'visible' : ''}`}>
				<ol className="UserMenu-user">
					{current.provider && current.provider.profile && current.provider.profile.uniqueName && (
						<li>
							<Link to={`/account/${current.provider.profile.uniqueName}`}>
								<span className="icon icon-person" />
								<span className="UserMenu-label">Account</span>
							</Link>
						</li>
					)}
					<li>
						<a href="https://b2me.zendesk.com" target="_blank" rel="noopener noreferrer">
							<span className="icon icon-help_outline" />
							<span className="UserMenu-label">Support</span>
						</a>
					</li>
					<li>
						<a href="#" onClick={logout}>
							<span className="icon icon-exit_to_app" />
							<span className="UserMenu-label">Logout</span>
						</a>
					</li>
				</ol>
				<div className="UserMenu-username">
					<span>Logged in as </span>
					<em>{current.user.username}</em>
				</div>
				<Notifications />
			</section>
		);
	}
}

const ConnectedUserMenu = connect(
	state => ({
		screenSize: state.ui.screenSize,
		userMenuShown: state.ui.userMenuShown,
		current: state.session && state.session.status === 'authenticated' && state.session.current
	}),
	dispatch => ({
		logout: () => dispatch(actions.logout()),
		toggleUserMenu: () => dispatch(uiActions.uiToggleUserMenu())
	})
)(UserMenu);

export default ConnectedUserMenu;



// WEBPACK FOOTER //
// ./src/user/UserMenu.js